/**
 * common路由
 */
import { RouteConfig } from 'vue-router'
import { TransparentBarStyle, HideCustomBar } from '@/utils/bar-style'
import useragent from '@finance/useragent'

const routers: RouteConfig[] = []
const barStyle = useragent.isSuishouji ? HideCustomBar : TransparentBarStyle

routers.push(
  {
    path: '/',
    meta: {
      title: '视频广告',
      barStyle,
      disabledKnPullRefresh: true
    },
    component: () => import(/* webpackChunkName: "_bury_" */ '@/views/index/index.vue')
  },
  {
    path: '/invite',
    meta: {
      title: '打开随手记',
      barStyle,
      disabledKnPullRefresh: true
    },
    component: () => import(/* webpackChunkName: "_bury_" */ '@/views/invite/invite.vue')
  }
)

export default routers
